module.exports = __webpack_public_path__ + "media/images/hiring-texting-d1fefeb0207ffb2feb06e1fa59badae9.svg";